module.exports = __webpack_public_path__ + "img/selectlistdetails.ea492543.png";